import { Box, CenteredBox, H1 } from '../../widgets'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { usePracticeWheel } from '../common/index.js'

export const Exited = () => {
  const { hide } = usePracticeWheel()

  useGSAP(() => {
    gsap.timeline()
      .call(hide)
  })

  return (
    <CenteredBox fullHeight fullWidth background="var(--blue)">
      <Box maxWidth={1440}>
        <H1 size={150} align="center" lineHeight="normal">
          Your Squiz has ended
        </H1>
      </Box>
    </CenteredBox>
  )
}
